import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgLastMessage = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.66665 3.66667H16.3333C17.2041 3.66667 17.9166 4.37917 17.9166 5.25001V14.75C17.9166 15.6208 17.2041 16.3333 16.3333 16.3333H3.66665C2.79581 16.3333 2.08331 15.6208 2.08331 14.75L2.09123 5.25001C2.09123 4.37917 2.79581 3.66667 3.66665 3.66667ZM9.99998 10.7917L16.3333 6.83334V5.25001L9.99998 9.20834L3.66665 5.25001V6.83334L9.99998 10.7917Z",
		fill: "#inherit"
	})
});
export default SvgLastMessage;
